export class FormatterHelper {

  static formatBytes(bytes, k=0, decimals = 2) {
    bytes = Number(bytes);
    if (bytes === 0) return '0 Bytes';

    k = k == 0? 1024: k;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  static uptimeToStr(input) {
    if (input == null) {
      return '-';
    }
    let day, hour, minutes, seconds, n;
    n = Math.floor(input);
    day = Math.floor(n / (24 * 3600));
    n = Math.floor(n % (24 * 3600));
    hour = Math.floor(n / 3600);
    n = Math.floor(n % 3600);
    minutes = Math.floor(n / 60);
    n = Math.floor(n % 60);
    seconds = n;
    let str = '';
    str = str + (day ? day + 'd ' : '');
    str = str + (hour ? hour + 'h ' : '');
    str = str + (minutes ? minutes + 'm ' : '');
    str = str + (seconds ? seconds + 's' : '');
    return str;
  }
  static uptimeToDecimal(input) {
    if (input == null) {
      return '-';
    }
    let day, hour, minutes, seconds, n;
    n = Math.floor(input);
    hour = (input / 3600);
    return hour;
  }
  static formatNumber(number, decimals = 2) {
    return Number(number).toFixed(decimals).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }  

  static stripCidr(value: any) {
    return String(value || '').split('/')[0] || '';
  }

  static cleanIpValue(value: any) {
    return String(value || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .join(' / ');
  }

  static joinCsv(value: any) {
    return String(value || '')
      .split(',')
      .map(item => item.trim())
      .filter(Boolean)
      .join(', ');
  }

  static getCsvValue(value: any, index: number) {
    return String(value || '')
      .split(',')
      .map(item => item.trim())
      .filter(Boolean)[index] || '';
  }

  static toNumber(value: any) {
    return Number(value) || 0;
  }

  static getTextValue(value: string | number | null | undefined, fallback: string) {
    const text = String(value ?? '').trim();
    return text || fallback;
  }

  static getNumberValue(value: string | number | null | undefined, fallback: string | number) {
    const normalized = value === null || value === undefined || value === '' ? fallback : value;
    const numberValue = Number(normalized);
    return Number.isFinite(numberValue) ? numberValue : 0;
  }

  static formatBytesShort(bytes: number | string | undefined, decimals = 2) {
    const value = Number(bytes);
    if (!value) {
      return '0 B';
    }

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(value) / Math.log(k));

    return parseFloat((value / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  static formatDuration(seconds: number) {
    const totalSeconds = Number(seconds) || 0;
    if (!totalSeconds) {
      return '-';
    }
    if (totalSeconds < 60) {
      return `${totalSeconds}s`;
    }

    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    if (days > 0) {
      return `${days}d:${hours}h`;
    }

    if (hours > 0) {
      return `${hours}h:${minutes}m`;
    }

    return `${minutes}m`;
  }

  static formatTotalUptime(uptimeSeconds: number, totalUptimeSeconds: number) {
    const uptime = FormatterHelper.formatDuration(uptimeSeconds);
    const total = FormatterHelper.formatDuration(totalUptimeSeconds);

    if (uptime === '-' && total === '-') {
      return '-';
    }

    if (total === '-' || uptime === total) {
      return uptime;
    }

    return `${uptime} / ${total}`;
  }

  static getTotalFromOrigDupes(value: any) {
    const [orig, dupes] = String(value || '0:0')
      .split(':')
      .map(part => FormatterHelper.toNumber(part));
    return orig + dupes;
  }

  static getUlayModeToken(value: string) {
    return String(value || '').toLowerCase().includes('source') ? 'source_interface' : 'route_tables';
  }

  static getTransportToken(value: string) {
    return String(value || '').toLowerCase().startsWith('tcp') ? 'tcp' : 'udp';
  }

  static getDistributionToken(value: string) {
    const normalized = String(value || '').toLowerCase();
    if (normalized.includes('block')) {
      return 'blocks';
    }
    if (normalized.includes('flow')) {
      return 'flows';
    }
    return 'packets';
  }

  static generateBase64UrlPsk(byteLength = 32) {
    const bytes = new Uint8Array(byteLength);
    const cryptoApi = window.crypto || (window as any).msCrypto;
    cryptoApi.getRandomValues(bytes);

    let binary = '';
    bytes.forEach(byte => binary += String.fromCharCode(byte));

    return btoa(binary)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/g, '');
  }

  static getStateClass(state: string) {
    const normalized = String(state || '').toLowerCase();
    if (!normalized || normalized === '-') {
      return 'status-empty';
    }
    if (normalized === 'up' || normalized === 'running' || normalized === 'ok' || normalized === 'local') {
      return 'status-up';
    }
    if (normalized === 'sleeping' || normalized === 'sleep') {
      return 'status-sleep';
    }
    if (normalized === 'pending') {
      return 'status-pending';
    }
    if (normalized === 'down' || normalized === 'initial') {
      return 'status-down';
    }
    return 'status-down';
  }

  static getStateLabel(state: string) {
    const normalized = String(state || '').toLowerCase();
    if (normalized === 'sleeping') {
      return 'SLEEP';
    }
    return String(state || '-').toUpperCase();
  }


}
